import { Button } from '@trustycars/genie-ui/components'
import { FC } from 'react'
import { main } from './styles.css'
import { BaseText } from '@trustycars/genie-ui/components/hook-fields'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { requiredTrimmedString } from '$hook-forms/general-validators'
import { TypeSubmitForm } from '$hook-forms/types'

export const schema = z.object({
  recoveryCode: requiredTrimmedString
})

export type TField = z.infer<typeof schema>

export type RecoveryCodeVerifyFormProps = TypeSubmitForm<TField> & {
  submitButtonText?: string
}

export const RecoveryCodeVerifyForm: FC<RecoveryCodeVerifyFormProps> = ({
  submitButtonText = 'Confirm',
  onSuccess,
  disabled
}) => {
  const methods = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      recoveryCode: ''
    },
    mode: 'all'
  })

  const { reset, handleSubmit, control, formState } = methods

  return (
    <form
      onSubmit={handleSubmit((...handler) => onSuccess(reset, ...handler))}
      className={main}
    >
      <BaseText
        name="recoveryCode"
        control={control}
        disabled={disabled}
        inputProps={{
          autoComplete: 'one-time-code',
          autoFocus: true
        }}
      />

      <Button type="submit" disabled={disabled || !formState.isDirty}>
        {submitButtonText}
      </Button>
    </form>
  )
}

export default RecoveryCodeVerifyForm
